import React from 'react';
import './CSS/PolicyPage.css';

const Returns = () => {
  return (
    <div className="policy-page container">
      <h1>Return Policy</h1>
      
      <div className="policy-section">
        <h2>1. General Policy</h2>
        <p>Due to the perishable nature of our food items, we do not accept returns. All sales are final. We are committed to providing you with high-quality, fresh food, and we encourage you to enjoy your order as soon as it is delivered.</p>
      </div>

      <div className="policy-section">
        <h2>2. Incorrect or Missing Items</h2>
        <p>If you receive an incorrect item or an item is missing from your order, please contact our support within 30 minutes of delivery. We will do our best to rectify the situation, which may include a credit or a re-delivery, at our discretion.</p>
      </div>

      <div className="policy-section">
        <h2>3. Quality Concerns</h2>
        <p>If you have a concern about the quality of your food, please contact us immediately. We may request a photo of the item in question to help us understand the issue. Resolutions are handled on a case-by-case basis.</p>
      </div>
    </div>
  );
};

export default Returns;